/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = '/search-api';
}

/**
 * Parameters for `SearchApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
